/*
 * Copyright Huesik (c) 2019.
 */

import VueDaumMap from 'vue-daum-map'

const MapConstant = {
  RANGE_SEARCH_DISTANCE: 700,
  //APP_KEY: 'ba6cde83c830d56de6f7f8835ffd79f4',
  APP_KEY: 'b98ef796b53b8557e2ed3fc019fb1319',
  LIBRARIES: ['services','clusterer','drawing'], // 추가로 불러올 라이브러리
  MAP_TYPE: VueDaumMap.MapTypeId.NORMAL, // 맵 타입
  DEFAULT_LOCATION: {
    LATITUDE: 37.5546788388674,
    LONGITUDE: 126.970606917394
  }
}

export default MapConstant